

import './App.css';
// import BigDial from './Components/BigDial/BigDial.js'


function App() {
  return (
    <div>
      <h1>dev</h1>
      <div className='flex-row space-around'>
        <a href="/big-dial">big dial</a>
        <a href="/monthly-output">monthly output</a>
        
        <a href="/comparison-chart">comparison chart</a>
      </div>
      <h1>Jackson 2</h1>
      <div className='flex-row space-around'>
        <a href="/tennessee/jackson2/big-dial" >big dial</a>
        <a href="/tennessee/jackson2/monthly-output">monthly output</a>
        
        <a href="/comparison-chart">comparison chart</a>
      </div>
      <h2>Paris</h2>
      <div className='flex-row space-around'>
        <a href="/tennessee/paris/big-dial" >big dial</a>
        <a href="/tennessee/paris/monthly-output">monthly output</a>
        
        <a href="/comparison-chart">comparison chart</a>
      </div>
    </div>
  );
}

export default App;
